import PropTypes from 'prop-types';

import LandingSlot from 'containers/LandingSlot';

export const Slots = ({ onLandingComponentClick, slotData, slotGroup, slotOrder, startSlot, endSlot }, { testId }) => (
  <div data-test-id={testId(slotGroup)}>
    {
      slotOrder.map(slotName => {
        const slotNumber = slotName.split('-')[1] || 31; // if slot name doesn't match primary-1 through primary-30, do not show the content (endSlot should never be over 30)
        return slotNumber > startSlot && slotNumber <= endSlot && <LandingSlot
          data={slotData[slotName]}
          key={slotName}
          onLandingComponentClick={onLandingComponentClick}
          slotName={slotName} />;
      })
    }
  </div>
);

Slots.contextTypes = {
  testId: PropTypes.func
};

export default Slots;
